export const columns = [
  {
    title: "Código",
    dataIndex: "codigo",
    width: "20%",
  },
  {
    title: "Estado",
    dataIndex: "estado",
    width: "20%",
  },
  {
    title: "Grado",
    dataIndex: "nombreGrado",
    width: "20%",
  },
];

export const camposFormulario = (objetos = [], grado = []) => {
  return {
    title: "Códigos Sobres",
    campos: [
      {
        name: "items",
        label: "Items",
        type: "multiple",
        opciones: objetos,
      },
      {
        name: "cantidad",
        label: "Cantidad",
        type: "number",
        max: 10,
        min: 1,
        rules: [
          {
            required: true,
            message: "La cantidad es obligatoria",
          },
        ],
      },
      {
        name: "grado",
        label: "Grado",
        type: "autocomplete",
        opciones: grado,
        extra: "Si se selecciona grado, se ignora el listado de items"
      },
    ],
  };
};
export const camposFilter = (estados = [], grados = []) => ({
  title: "Códigos Sobres",
  campos: [
    {
      name: "mostrarUsados",
      placeholder: "Estado",
      type: "autocomplete",
      opciones: estados,
    },
    {
      name: "grado",
      placeholder: "Grado",
      type: "autocomplete",
      opciones: grados,
    },
  ],
});
